export default {
  state: {
    title: 'Status',
    visible: 'Bordbestilling synlig',
    on: 'Bordbestilling',
  },
  notes: {
    hidden: {
      title: 'Bordbestilling er skjult',
      description:
        'Den er slået til, men din shop viser den ikke, så alle bordbestillinger afvises. Slå „Bordbestilling synlig“ til for at vise den.',
      link: 'Gå til kontakten',
    },
    off: {
      title: 'Gæster kan ikke bestille ved bordet nu',
      description:
        'Slå begge kontakter til for at komme i gang. Indtil da åbner et bords QR-kode din shop med Afhentning og Levering.',
    },
    no_active_table: {
      title: 'Gæster kan endnu ikke bestille ved bordet',
      description: 'Tilføj et bord nedenfor, og slå det til.',
    },
  },
  buttons: {
    save: 'Gem',
  },
};
